import { combineReducers } from 'redux';
import CoreReduxStore from '@/core/reducers/CoreReduxStore';
import TCoreReduxStore from '@/core/types/TCoreReduxStore';

const reduxStorages = new CoreReduxStore( { screenCode: "COM", serviceCode: "SS" } as TCoreReduxStore )

/**
 * - Site Settings api sinden alınan veriler burada depolanır.
 * - Herhangi bir sayfaya bağlı kalmaksızın verilerin depolanması için 
 *   screenCode COM(Common) ve serviceCode SS(SiteSettings) olarak set edilmiştir.
 */

const SiteSettingStore = combineReducers({

    ...reduxStorages.LIST(),
    ...reduxStorages.DETAILS(),

});

export default SiteSettingStore;